export function classUtils(...args: (string|boolean|undefined)[]) {
    return args.filter((className) => typeof className !== 'undefined' && !!className).join(' ')
}
